// @flow

import React from 'react';
import { NavLink } from 'react-router-dom';
import { type Props } from '.';

const MoreInfo = (props: Props) => {
  const {
    children,
    addCurrentSearchParamsToHistory,
    hasPossibleMatches,
    hasAlternativeTitles,
  } = props;
  const openPossibleMatches = () => {
    addCurrentSearchParamsToHistory();
  };
  return (
    <React.Fragment>
      <div className="search-pane--more-info">
        {children}
      </div>
      <div className="d-flex flex-row more-info--buttons">
        {hasAlternativeTitles && (
          <NavLink to="/alternativetitles" className="btn btn-prs flex-shink-1 btn-outline-pigdeon btn-sm">
            <span className="prs-icon prs-icon-matches" />
            <br />
            Alternative title
          </NavLink>
        )}
        {hasPossibleMatches && (
          <NavLink to="/possiblematches" onClick={openPossibleMatches} className="btn btn-prs flex-shink-1 btn-outline-pigdeon btn-sm">
            <span className="prs-icon prs-icon-alt-titles" />
            <br />
            Possible matches
          </NavLink>
        )}
      </div>
    </React.Fragment>
  );
};

export default MoreInfo;
